
export const ADMINURL =process.env.REACT_APP_ADMIN_API;
export const ADMINLOGINLINK =process.env.REACT_APP_ADMINLOGIN_LINK;
